import { useTheme } from "@emotion/react";

import { StyledMenuItemText } from "@/components/shared/MenuItem/styles";
import { MenuItemProps } from "@/components/shared/MenuItem/types";

export const MenuItem: React.FC<MenuItemProps> = ({
  text,
  type = "primary",
}) => {
  const theme = useTheme();
  const color = {
    primary: theme.palette.primary[500] || "",
    danger: theme.palette.secondary.red[500] || "",
    disabled: theme.palette.grey[500] || "",
  };

  return (
    <StyledMenuItemText color={color[`${type}`]} variant='text2'>
      {text}
    </StyledMenuItemText>
  );
};
